import { ApiService } from "@/services/api/ApiService";
import type { ConversationRecapResult, RecapTranscriptTurn } from "@/types/voice/conversation-recap";

/**
 * Generates a short, inline recap (2-3 bullets) from a conversation transcript.
 * The live-agent surface is consumer-facing and often anonymous, so this is
 * invoked in "public" mode — `ApiService` falls back to the `x-public-request`
 * header when there's no auth token.
 */
export class ConversationRecapService {
  static async generate(transcript: RecapTranscriptTurn[]): Promise<string[]> {
    try {
      const response = await ApiService.invoke<ConversationRecapResult>(
        {
          resource: "conversations",
          action: "recap",
          data: { transcript },
        },
        "public",
      );
      return response?.bullets ?? [];
    } catch (error) {
      console.error("Conversation recap failed:", error);
      return [];
    }
  }
}
